module.exports = __webpack_public_path__ + "img/about6.19def71a.jpg";